import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { CONTACTS_ROUTE } from "../../utils/constants";

const StyledWorksBox = styled.div`
  max-width: 964px;
  width: 100%;
  min-height: 100%;
  display: flex;
  column-gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem;
  background: #0f0f16;
  box-shadow: 0px 4px 3px 2px rgba(0, 0, 0, 0.25);
`;

const TextInfo = styled.p`
  color: #c4c4c4;
`;

const StyledLink = styled.a`
  color: #fffa79;
`;

const NotElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin: 5rem auto;
`;

export const WorksBox = () => {
  return (
    <StyledWorksBox>
      <NotElement>
        <TextInfo>Здесь пока пусто... :( </TextInfo>
        <StyledLink as={Link} to={CONTACTS_ROUTE}>
          Станьте первым в этом списке!
        </StyledLink>
      </NotElement>
    </StyledWorksBox>
  );
};
